import Match from '@core/models/offer/Match';

export default class SuperOffer {
    [key: string]: Match[]
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/models/offer/SuperOffer.ts